<template>
  <ul class="menu-list">
    <router-link v-for="item in menuItems" :key="item.name" :to="item.route" activeClass="active" tag="li">
      <a>
        {{ item.name }} <span v-if="item.name === 'Surveys' && incompleteSurveysCount > 0" class="tag is-rounded is-warning">{{ incompleteSurveysCount }}</span>
        <div v-if="showIcons(item.route)" class="menu-icons is-pulled-right">
          <router-link v-if="item.showReportIcon" tag="i" :to='`${item.route}/reports`' class="mdi mdi-sort-variant ">
          </router-link>
          <router-link v-if="loggedUser.role !== 'User'" tag="i" :to='`${item.route}/add`' class="mdi mdi-plus-box">
          </router-link>
        </div>
      </a>
    </router-link>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Menu',
  props: {
    role: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      loggedUser: 'auth/loggedUser',
      menuItems: 'auth/menuItems'
    }),
    incompleteSurveysCount() {
      return this.$store.getters['survey/incompleteSurveysCount']
    }
  },
  methods: {
    showIcons(route) {
      return this.$route.path.includes(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseMenuList.vue